import React, { useEffect, useState } from "react";
import AccountsButton from "../Accounts/AccountsButton";
import $ from "jquery";
import MasterList from "../Master/MasterListItem";
import DebitCreditBody from "./DebitCreditBody";
import Messagedialogbox from "../General/Messagedialogbox";

import SideMenu from "../General/SideMenu";
import { Show_MsgBox, setload_Screen } from "../ReduxStore/Message";
import { useDispatch } from "react-redux";
import { userApp} from "../Admin/Utility";
function CreditNote() {
  const dispatch = useDispatch();
  const iScrId = 44;
  const [iCreId, setiCreId] = useState(0);
  const [strTransNo, setstrTransNo] = useState("");
  const [isManualNo, setisManualNo] = useState(false);
  const [strVouchNo, setstrVouchNo] = useState("");
  const [strVouchDate, setstrVouchDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [iVenTypeId, setiVenTypeId] = useState(1);
  const [iVouchId, setiVouchId] = useState(0);
  const [iVenId, setiVenId] = useState(0);
  const [strVenName, setstrVenName] = useState("");
  const [strRemark, setstrRemark] = useState("");
  const [dAmount, setdAmount] = useState(0);
  const [iCreCount, setiCreCount] = useState(0);
  const [iCallerScrId, setiCallerScrId] = useState(0);
  const [bCancelStatus, setbCancelStatus] = useState(false);
  const [listNoFormat, setlistNoFormat] = useState([0]);
  const [listCreditNote, setlistCreditNote] = useState([]);
  const [listVenType, setlistVenType] = useState([]);
  const [listEntComBox, setlistEntComBox] = useState([]);
  const [ListValidateProperties, setListValidateProperties] = useState([]);

  useEffect(() => {
    Load_CreditNote();
  }, []);

  const Load_CreditNote = async () => {
    try {
      const parems = {
        iScrId: iScrId,
        strCompanyDB: localStorage.db,
        iClientId: Number(localStorage.ClientId),
        iUserId: Number(localStorage.UserId),
        iRoleId: Number(localStorage.RoleId),
      };

      await dispatch(setload_Screen(true));
      await userApp.post(`CreditNote/Load_CreditNote`, parems).then((res) => {
        if (res.data.strStatus === "Success") {
          setlistEntComBox(res.data.objEntComBox);
          setlistVenType(res.data.objEntVenType);
          setlistCreditNote(res.data.objEntCreditNote);
          setiCreCount(listCreditNote.length);
          setlistNoFormat(res.data.objEntNoFormat);
          setisManualNo(res.data.objEntNoFormat[0].isManualNumber);
          setstrTransNo(res.data.objEntNoFormat[0].strTransNo);
          setstrVouchNo(res.data.objEntNoFormat[0].strUserNo);
          setListValidateProperties(res.data.Transtab);
          TabOrderAssign(res.data.Transtab);
        } else {
          AlertMessage(res.data.strMessage, "error");
        }
      });
    } catch (e) {
      AlertMessage(e.message, "info");
    } finally {
      dispatch(setload_Screen(false));
    }
  };
  const Search_CreditNote = (strtxt) => {
    const objsearch = {
      strSearch: strtxt,
      strColName: "All",
      strCompanyDB: localStorage.db,
    };
    userApp.post(`CreditNote/Search_CreditNote/`, objsearch).then((Res) => {
      if (Res.data.strStatus === "Success")
        setlistCreditNote(Res.data.objEntCreditNote);
      else {
        AlertMessage(Res.data.strMessage, "error");
      }
    });
  };
  const AlertMessage = (Message, Icon) => {
    dispatch(Show_MsgBox({ Message: Message, Type: Icon, isMsg: true }));
  };
  const View_Party = (Party) => {
    setiVenId(Party.partyId);
    setstrVenName(Party.partyName);
  };
  const ClearClick = () => {
    setdAmount(0);
    setiVenId(0);
    setiVenTypeId(1);
    setiVouchId(0);
    setiCreId(0);
    setiCallerScrId(0);
    setstrVenName("");
    setstrRemark("");
    setstrTransNo("");
    setstrVouchNo("");
    setstrVouchDate(new Date().toISOString().split("T")[0]);
    setbCancelStatus(false);
    setlistNoFormat([]);
    setlistCreditNote([]);
    Load_CreditNote();
  };
  const DeleteClick = () => {
    dispatch(setload_Screen(true));
    userApp.post("CreditNote/Cancel/" + iCreId + "/" + localStorage.db).then(
      (json) => {
        if (json.data.strStatus === "Success") {
          AlertMessage(json.data.strMessage, "success");
          ClearClick();
        } else {
          AlertMessage(json.data.strMessage, "error");
        }
        dispatch(setload_Screen(false));
      }
    );
  };
  const DeleteIconClick = (CreId) => {
    dispatch(setload_Screen(true));
    userApp.post("CreditNote/Cancel/" + CreId + "/" + localStorage.db).then(
      (json) => {
        if (json.data.strStatus === "Success") {
          ClearClick();
          AlertMessage(json.data.strMessage, "success");
        } else {
          AlertMessage(json.data.strMessage, "error");
        }
        dispatch(setload_Screen(false));
      }
    );
  };
  const SaveClick = () => {
    dispatch(setload_Screen(true));
    const objInsUpdCre = {
      strPrefix: listNoFormat[0].strPrefix,
      iNumSeqNo: listNoFormat[0].iNumSeqNo,
      strCompCode: listNoFormat[0].strCompCode,
      strFinanFrom: listNoFormat[0].strFinanFrom,
      strCreNo: strVouchNo,
      strTransNo: strTransNo,
      dpCreDate: strVouchDate,
      iVenType: iVenTypeId,
      iVenId: iVenId,
      dAmount: dAmount,
      strRemark: strRemark,
      iVouchId: iVouchId,
      iCallerScrId: iCallerScrId,
      iCreId: iCreId,
      strFilter: "",
      strFilterColumn: "",
      strSearch: "",
      strVenName: "",
      strCompanyDB: localStorage.db,
    };
    userApp.post("CreditNote/InsertUpdate/", objInsUpdCre).then((json) => {
      if (json.data.strStatus === "Success") {
        ClearClick();
        AlertMessage(json.data.strMessage, "success");
      } else {
        AlertMessage(json.data.strMessage, "error");
      }
      dispatch(setload_Screen(false));
    });
  };
  const GetCreditNoteDetails = (CreId) => {
    dispatch(setload_Screen(true));
    userApp.post(
      "CreditNote/GetCreditNoteDetails/" + CreId + "/" + localStorage.db
    ).then((json) => {
      if (json.data.strStatus === "Success") {
        setiCreId(CreId);
        setstrVouchNo(json.data.objCreDetails.strCreNo);
        var CEDate = json.data.objCreDetails.dpCreDate;
        CEDate = CEDate.split(" ");
        CEDate = CEDate[0];
        CEDate = CEDate.split("-").reverse().join("-");
        setstrVouchDate(CEDate);
        setstrTransNo(json.data.objCreDetails.strTransNo);
        setiVenTypeId(json.data.objCreDetails.iVenType);
        setiVenId(json.data.objCreDetails.iVenId);
        setstrVenName(json.data.objCreDetails.strVenName);
        setstrRemark(json.data.objCreDetails.strRemark);
        setdAmount(json.data.objCreDetails.dAmount);
        setbCancelStatus(json.data.objCreDetails.bCancelStatus);
      } else {
        AlertMessage(json.data.strMessage, "error");
      }
      dispatch(setload_Screen(false));
    });
  };
  const OnChange = (e) => {
    switch (e.target.name) {
      case "strVouchNo":
        setstrVouchNo(e.target.value);
        break;
      case "strVouchDate":
        setstrVouchDate(e.target.value);
        break;
      case "strRemark":
        setstrRemark(e.target.value);
        break;
      case "dAmount":
        setdAmount(Number(e.target.value));
        break;
      default:
        break;
    }
  };
  const OnSelectionChange = (e) => {
    setiVenTypeId(Number(e.target.value));
    setstrVenName("");
    setiVenId(0);
  };
  //#region TabSetting
  const [ListTabOrder, setListTabOrder] = useState([
    {
      VoucherTab: "",
      TransNoTab: "",
      TranDate: "",
      VouchDateTap: "",
      VenNameTab: "",
      VenTypeTab: "",
      AmountTab: "",
      Remarktab: "",
      CreditNoteListTab: "",
      CreditNoteFIlterTab: "",
      CreditNoteSearchTab: "",
      BtnSavtab: "",
      BtnCleartab: "",
      BtnDeletetab: "",
      BtnClosetab: "",
      BtnCancel: "",
    },
  ]);
  const TabOrderAssign = (EntProperties) => {
    let TabOrder = ListTabOrder;
    EntProperties = EntProperties.filter((Data) => Data.isTabStop === true);
    for (var i = 0; i < EntProperties.length; i++) {
      switch (EntProperties[i].strCtrlName) {
        case "txtEntNo":
          TabOrder[0].TransNoTab = EntProperties[i].iTabIndex;
          break;
        case "dpEntDate":
          TabOrder[0].TranDate = EntProperties[i].iTabIndex;
          break;
        case "txtVouchNo":
          TabOrder[0].VoucherTab = EntProperties[i].iTabIndex;
          break;
        case "dpVouchDate":
          TabOrder[0].VouchDateTab = EntProperties[i].iTabIndex;
          break;
        case "cbVenType":
          TabOrder[0].VenTypeTab = EntProperties[i].iTabIndex;
          break;
        case "txtVenName":
          TabOrder[0].VenNameTab = EntProperties[i].iTabIndex;
          break;
        case "txtRemark":
          TabOrder[0].Remarktab = EntProperties[i].iTabIndex;
          break;
        case "txtAmt":
          TabOrder[0].AmountTab = EntProperties[i].iTabIndex;
          break;
        case "btnSave":
          TabOrder[0].BtnSavtab = EntProperties[i].iTabIndex;
          break;
        case "btnClear":
          TabOrder[0].BtnCleartab = EntProperties[i].iTabIndex;
          break;
        case "btnCancel":
          TabOrder[0].BtnCancel = EntProperties[i].iTabIndex;
          break;
        case "btnClose":
          TabOrder[0].BtnClosetab = EntProperties[i].iTabIndex;
          break;
        case "cbFilter":
          TabOrder[0].CreditNoteFIlterTab = EntProperties[i].iTabIndex;
          break;
        case "txtSearch":
          TabOrder[0].CreditNoteSearchTab = EntProperties[i].iTabIndex;
          break;
        case "lbVouchers":
          TabOrder[0].CreditNoteListTab = EntProperties[i].iTabIndex;
          break;
        default:
          break;
      }
    }
    var maxTab = EntProperties.reduce(
      (prev, current) => (prev.iTabIndex > current.iTabIndex ? prev : current),
      0
    ); //returns object
    sessionStorage.maxTab = maxTab.iTabIndex;
    setListTabOrder(TabOrder);
  };
  const TabIndex = (e) => {
    var maxTab = Number(sessionStorage.maxTab);
    var ActiveIndex = document.activeElement.tabIndex;
    if (e.key === "ArrowLeft") {
      if (ActiveIndex > 0 && ActiveIndex <= maxTab) {
        if (ActiveIndex - 1 === ListTabOrder[0].CreditNoteListTab) {
          $(".react-table .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex - 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex - 1) + "']").select();
        }
      } else {
        if (maxTab - 1 === ListTabOrder[0].CreditNoteListTab) {
          $(".react-table .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (maxTab - 1) + "']").focus();
          $("[tabindex='" + (maxTab - 1) + "']").select();
        }
      }
    }
    if (e.key === "ArrowRight") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (ActiveIndex + 1 === ListTabOrder[0].CreditNoteListTab) {
          $(".react-table .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "Enter") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (ActiveIndex + 1 === ListTabOrder[0].CreditNoteListTab) {
          $(".react-table .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "ArrowDown") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (ActiveIndex + 1 === ListTabOrder[0].CreditNoteListTab) {
          $(".react-table .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "ArrowUp") {
      if (ActiveIndex > 0 && ActiveIndex <= maxTab) {
        if (ActiveIndex - 1 === ListTabOrder[0].CreditNoteListTab) {
          $(".react-table .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex - 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex - 1) + "']").select();
        }
      } else {
        if (maxTab - 1 === ListTabOrder[0].CreditNoteListTab) {
          $(".react-table .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (maxTab - 1) + "']").focus();
          $("[tabindex='" + (maxTab - 1) + "']").select();
        }
      }
    }
  };
  //#endregion
  const PropertiesValidation = () => {
    var ErrorMsg = true;
    let ValidateItem = ListValidateProperties.filter(
      (Data) => Data.isValidate === true
    );
    for (var i = 0; i < ValidateItem.length; i++) {
      switch (ValidateItem[i].strCtrlName) {
        case "txtVouchNo":
          ErrorMsg = strVouchNo === "" ? false : true;
          break;
        case "dpVouchDate":
          ErrorMsg = strVouchDate === "" ? false : true;
          break;
        case "cbVenType":
          ErrorMsg = iVenTypeId.toString() === "0" ? false : true;
          break;
        case "txtVenName":
          ErrorMsg = strVenName === "" ? false : true;
          break;
        case "txtRemark":
          ErrorMsg = strRemark === "" ? false : true;
          break;
        case "txtAmt":
          ErrorMsg = dAmount.toString() === "0" ? false : true;
          break;
        default:
          break;
      }
      if (ErrorMsg === false) {
        AlertMessage(ValidateItem[i].strErrorMsg, "error");
        return ErrorMsg;
      }
    }
    return ErrorMsg;
  };
  return (
    <>
      <SideMenu ScrId={iScrId} />
      <div className="Master-container">
        <MasterList
          ComBoxValue={listEntComBox}
          EntList={listCreditNote}
          GetDetails={GetCreditNoteDetails}
          Delete={DeleteIconClick}
          Count={iCreCount}
          Search={Search_CreditNote}
          ScreenID={iScrId}
          accessor="strCreNo"
          accessorid="iCreId"
          ListTab={ListTabOrder[0].CreditNoteListTab}
          FilterTab={ListTabOrder[0].CreditNoteFIlterTab}
          SearchTab={ListTabOrder[0].CreditNoteSearchTab}
          onKeyDown={(e) => TabIndex(e)}
        />
        <div className="Master-card">
          <div className="Master-wrapper">
            <DebitCreditBody
              ScrId={iScrId}
              strVouchNo={strVouchNo}
              strTransNo={strTransNo}
              strVouchDate={strVouchDate}
              iVenTypeId={iVenTypeId}
              strVenTypeName={""}
              strVenName={strVenName}
              strRemark={strRemark}
              dAmount={dAmount}
              listVenType={listVenType}
              View_Party={View_Party}
              OnSelectionChange={OnSelectionChange}
              OnChangeEvent={OnChange}
              ListTabOrder={ListTabOrder}
              TabIndex={TabIndex}
              isManualNo={isManualNo}
            />
            <Messagedialogbox />
          </div>
          <AccountsButton
            ScrId={iScrId}
            Save={(e) => {
              if (PropertiesValidation()) {
                dispatch(
                  Show_MsgBox({
                    Button: SaveClick,
                    Question: "Do You Want to Save Credit Note?",
                    isdialog: true,
                  })
                );
              }
            }}
            Clear={ClearClick}
            Cancel={(e) => {
              if (iCreId === 0) {
                AlertMessage("Please Select Credit Note", "info");
              } else {
                dispatch(
                  Show_MsgBox({
                    Button: DeleteClick,
                    Question: "Do You Want to Want to Cancel Credit Note?",
                    isdialog: true,
                  })
                );
              }
            }}
            CancelStatus={bCancelStatus}
            SaveIndex={ListTabOrder[0].BtnSavtab}
            CloseIndex={ListTabOrder[0].BtnClosetab}
            ClearIndex={ListTabOrder[0].BtnCleartab}
            CancelIndex={ListTabOrder[0].BtnCancel}
            TabIndex={TabIndex}
            ScrName="CreditNote"
            Iid={iCreId}
          />
        </div>
      </div>
    </>
  );
}
export default CreditNote;
